module.exports = __webpack_public_path__ + "img/GALERIA-XL7-2021-4.e2574ab5.jpg";